module.exports = __webpack_public_path__ + "img/40_38_031_830.4c9a74f0.jpg";